import { useEffect, useRef, useReducer } from 'react';
const SET_IS_VISIBLE = 'SET_IS_VISIBLE';
const SET_OPTIONS = 'SET_OPTIONS';
const initialState = {
    options: {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
    },
    isVisible: false,
    wasVisible: false,
};
const Reducer = (state, action) => {
    switch (action.type) {
        case SET_IS_VISIBLE:
            return Object.assign(Object.assign({}, state), { isVisible: action.payload || state.wasVisible, wasVisible: true });
        case SET_OPTIONS:
            return Object.assign(Object.assign({}, state), { options: action.payload });
        default:
            return state;
    }
};
export const useLazyLoad = (options) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    const containerRef = useRef(null);
    const callback = entries => {
        const [entry] = entries;
        dispatch({ type: SET_IS_VISIBLE, payload: entry.isIntersecting });
    };
    useEffect(() => {
        if (options) {
            dispatch({ type: SET_OPTIONS, payload: options });
        }
    }, [options]);
    useEffect(() => {
        const observer = new IntersectionObserver(callback, options);
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [containerRef, options, state.options]);
    return Object.assign(Object.assign({}, state), { containerRef });
};
